import { useStaticQuery, graphql } from 'gatsby';
import { useLocation } from '@reach/router'; // eslint-disable-line import/no-unresolved
import { MdEmail } from 'react-icons/md';
import { RiTwitterFill, RiLinkedinFill, RiFacebookFill } from 'react-icons/ri';

interface Props {
  title: string;
  relativeUrl?: string;
  absoluteUrl?: string;
}

export default function SocialShare({
  title,
  relativeUrl,
  absoluteUrl,
}: Props) {
  const { site } = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
          siteUrl
        }
      }
    }
  `);

  const { pathname } = useLocation() || '';
  const url =
    absoluteUrl ||
    site.siteMetadata.siteUrl + relativeUrl ||
    site.siteMetadata.siteUrl + pathname;

  return (
    <div className="social-list social-list--share">
      <span className="social-list__label">Share:</span>
      <ul>
        <li>
          <a
            href={`https://www.facebook.com/sharer/sharer.php?u=${url}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <RiFacebookFill title="Share on Facebook" />
          </a>
        </li>
        <li>
          <a
            href={`https://twitter.com/share?text=${title}&url=${url}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <RiTwitterFill title="Share on Twitter" />
          </a>
        </li>
        <li>
          <a
            href={`https://www.linkedin.com/shareArticle?mini=true&url=${url}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <RiLinkedinFill title="Share on LinkedIn" />
          </a>
        </li>
        <li>
          <a
            href={`mailto:?subject=Shared from ${site.siteMetadata.title}&body=${title}: ${url}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <MdEmail title="Share by Email" />
          </a>
        </li>
      </ul>
    </div>
  );
}
